<template>
    <div>
        <div class="simple-form flex col-2">
            <div class="form-group center">
                <div class="form-label">
                    <label>适用范围名称</label>
                </div>
                <div class="form-value">
                    <span>{{realSignGroup.name || ""}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>签约主体</label>
                </div>
                <div class="form-value">
                    <span>{{realSignGroup.realComName || ""}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>适用范围</label>
                </div>
                <div class="form-value">
                    <span>{{merchantTypeMap[realSignGroup.merchantType]}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>描述</label>
                </div>
                <div class="form-value">
                    <span>{{realSignGroup.memo || ""}}</span>
                </div>
            </div>
        </div>
        <div class="content-caption dashed">
            <span>适用公司信息</span>
        </div>
        <el-table class="multipleTable" :data="realSignComList" ref="realComList" border style="width: 100%; font-size: 12px">
            <el-table-column prop="realComName" label="适用公司名称"></el-table-column>
            <el-table-column prop="realComInfo.code" label="公司代码" width="100"></el-table-column>
            <el-table-column prop="realComInfo.socialCreditCode" label="统一社会信用代码" width="200"></el-table-column>
            <el-table-column prop="realComInfo.taxPayType" label="纳税类型" width="120">
                <template slot-scope="rows">
                    <span v-if="rows.row.realComInfo.taxPayType == 0">无</span>
                    <span v-if="rows.row.realComInfo.taxPayType == 1">小规模纳税人</span>
                    <span v-if="rows.row.realComInfo.taxPayType == 2">一般纳税人</span>
                </template>
            </el-table-column>
            <el-table-column prop="realComInfo.taxFree" label="是否抵扣税" width="120">
                <template slot-scope="rows">
                    <span v-if="rows.row.realComInfo.taxFree == 0">根据业务确定</span>
                    <span v-if="rows.row.realComInfo.taxFree == 1">抵扣税</span>
                    <span v-if="rows.row.realComInfo.taxFree == 2">不抵扣税</span>
                </template>
            </el-table-column>
            <el-table-column prop="realComInfo.contactName" label="联系人" width="120"></el-table-column>
            <el-table-column prop="realComInfo.contactTel" label="联系电话" width="160"></el-table-column>
        </el-table>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox, Routes} from '../../app.vues'

    import merchtComnApi from '../../api/merchtComn'

    export default {
        name: 'swb-real-sign-group-detail',
        desc: '签约组详情',
        props: ['groupId'],
        data: function () {
            return {
                realSignGroup: {},
                realSignComList: [],
                merchantTypeMap: getEnumMap("merchantType", "value2text")
            }
        },
        created: function () {
            if (!Utils.isNoB(this.groupId)) {
                this.getRealSignGroupInfo();
            }
        },
        methods: {
            getRealSignGroupInfo: function () {
                let self = this;
                let theLoading = MsgBox.loading();
                merchtComnApi.getRealSignGroupInfo({groupId: this.groupId, includeItem: true}, function (result) {
                    theLoading.close();
                    if (result.type == 'info') {
                        self.realSignGroup = result.data || {};
                        //
                        self.realSignComList = Utils.merge([], self.realSignGroup.realSignComList);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/realCom/RealSignDetail.vue